import { Fragment, ReactElement, useMemo } from 'react';
import { IdAmbito } from 'shell/constants/id-ambito';
import { getBaseUrl } from 'notifications-from-civil-status/utils/get-base-url';
import { useParams } from 'react-router-dom';
import { CivilUnionDetailNotificationsResidentCrumbs } from 'notifications-from-civil-status/constants/breadcrumb';
import { CivilUnionDetailNotificationsResidentSubscriptionCrumbs } from 'subscription/constants/breadcrumb';
import { CivilUnionDetailNotificationsResidentMutationCrumbs } from 'mutation/constants/research-notifications-civil-status.crumbs';
import { CivilUnionDetailNotificationsResidentCancellationsCrumbs } from 'cancellations/constants/breadcrumb';
import { CivilUnionDetailNotificationsResidentCivilStatusCrumbs } from 'civil-status/constants/breadcrumb';
import RegistrationCivilUnionNotificationShared from 'shell/components/shared/research-notifications/research-civil-union/detail';

interface RegistrationCivilUnionDetailNotificationsCivilStatusSharedProps {
  scope?: string;
  isOther?: boolean;
}

const RegistrationCivilUnionDetailNotificationsCivilStatusShared = ({
  scope,
  isOther,
}: RegistrationCivilUnionDetailNotificationsCivilStatusSharedProps): ReactElement => {
  const params = useParams();

  const idAnsc = useMemo(() => {
    return params.id || undefined;
  }, [params.id]);
  const idCat = params.idCat || undefined;
  const idNotifica = params.idNotifica || '';

  const baseUrl: string = useMemo(() => {
    return getBaseUrl(scope, idCat);
  }, [scope, idCat]);

  const goBackUrl: string = useMemo(() => {
    return `${baseUrl}/modifica/${idAnsc}/${idNotifica}`;
  }, [baseUrl, idAnsc, idNotifica]);

  const goBackUrlDetail: string = useMemo(() => {
    return `${getBaseUrl(scope, idCat)}/visualizza/${idAnsc}/${idNotifica}`;
  }, [scope, idAnsc, idCat]);

  const items = useMemo(() => {
    if (idCat) {
      return CivilUnionDetailNotificationsResidentCivilStatusCrumbs(goBackUrl, idCat);
    }

    if (!scope) {
      return CivilUnionDetailNotificationsResidentCrumbs(goBackUrl);
    }

    switch (scope) {
      case IdAmbito.Iscrizioni:
        return CivilUnionDetailNotificationsResidentSubscriptionCrumbs(goBackUrl);
      case IdAmbito.Mutazioni:
        return CivilUnionDetailNotificationsResidentMutationCrumbs(goBackUrl);
      case IdAmbito.Cancellazioni:
        return CivilUnionDetailNotificationsResidentCancellationsCrumbs(goBackUrl);
      default:
        return [];
    }
  }, [scope, idCat]);

  return (
    <Fragment>
      <RegistrationCivilUnionNotificationShared
        goBackUrl={goBackUrl}
        items={items}
        goBackUrlDetail={goBackUrlDetail}
        isOther={isOther}
      />
    </Fragment>
  );
};

RegistrationCivilUnionDetailNotificationsCivilStatusShared.displayName =
  'Research Civil Union Detail Notifications CivilStatusShared component';

export default RegistrationCivilUnionDetailNotificationsCivilStatusShared;
